/**
 * Created by Denis Kuzin on 17 july 2023
 */

const PointerView = cleverapps.Spine.extend({
    avoidNode: "PointerView",
    ctor: function (options) {
        this._super(bundles.finger.jsons.arrow_json);

        this.options = options || {};
        this.target = this.options.target;
        this.targetOffset = this.options.targetOffset || 0;

        this.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 10000);

        const scene = cleverapps.Scenes.GetRunningScene();
        scene.addChild(this);

        this.onAfterResize();

        cleverapps.eventBus.on("openWindow", this.createListener(this.setVisible.bind(this, false)), this);
        cleverapps.eventBus.on("closeWindows", this.createListener(this.setVisible.bind(this, true)), this);
    },

    onAfterResize: function () {
        // The target can be detached mid-resize (e.g. a Resizable window rebuilding its content);
        if (!this.target || !this.target.isRunning()) {
            return;
        }

        const targetRect = this.target.getSceneBoundingBox();
        const pointerPosition = cc.rectGetCenter(targetRect);

        const direction = this.guessDirection(pointerPosition);

        if (this.direction !== direction) {
            this.direction = direction;
            this.setAnimation(0, this.direction, true);
        }

        const step = [PointerView.DIRECTIONS.DOWN, PointerView.DIRECTIONS.LEFT].includes(this.direction) ? 1 : -1;

        if ([PointerView.DIRECTIONS.UP, PointerView.DIRECTIONS.DOWN].includes(this.direction)) {
            pointerPosition.y += ((targetRect.height + this.height) / 2 + this.targetOffset) * step;
        } else {
            pointerPosition.x += ((targetRect.width + this.width) / 2 + this.targetOffset) * step;
        }
        
        this.setPosition(pointerPosition);
    },

    guessDirection: function (targetPosition) {
        if (this.options.direction) {
            return this.options.direction;
        }

        if (this.target instanceof MenuBarItemView) {
            return PointerView.DIRECTIONS.RIGHT;
        }
        if (typeof CardView !== "undefined" && this.target instanceof CardView) {
            return PointerView.DIRECTIONS.DOWN;
        }
        if (!this.target.getParent()) {
            return PointerView.DIRECTIONS.UP;
        }

        const sceneSize = cleverapps.resolution.getSceneSize();

        if (targetPosition.y > sceneSize.height * 4 / 5) {
            return PointerView.DIRECTIONS.UP;
        }

        if (targetPosition.x < sceneSize.width / 5) {
            return PointerView.DIRECTIONS.LEFT;
        }

        if (targetPosition.x > sceneSize.width * 4 / 5) {
            return PointerView.DIRECTIONS.RIGHT;
        }

        return PointerView.DIRECTIONS.DOWN;
    }

});

PointerView.create = function (options) {
    options = options || {};

    const pointer = new PointerView(options);

    PointerView.remove(PointerView.currentPointer);
    PointerView.currentPointer = pointer;

    addCleaner(pointer, () => {
        PointerView.remove(pointer);
    });

    return pointer;
};

PointerView.remove = function (pointer) {
    if (!pointer || PointerView.currentPointer !== pointer) {
        return;
    }

    PointerView.currentPointer = undefined;
    pointer.removeFromParent();
};

PointerView.DIRECTIONS = {
    UP: "up",
    DOWN: "down",
    LEFT: "left",
    RIGHT: "right"
};